import { Component } from 'react'
import { BrowserRouter as Router } from 'react-router-dom'
import { ThemeProvider } from '@material-ui/core'
import CssBaseline from '@material-ui/core/CssBaseline'
import './App.css'
import Routes from './routes/Routes'
import theme from './theme'
import { AuthProvider } from 'context/AuthContext'
import { UserProvider } from 'context/UserContext'
// The contexts could potentially be consolidated at some point

// Router reference here: https://reacttraining.com/react-router/web/guides/quick-start

class App extends Component {
    render() {
        return (
            <>
                <CssBaseline />
                <ThemeProvider theme={theme}>
                    <AuthProvider>
                        <UserProvider>
                            <Router>
                                <div className="App">
                                    <Routes />
                                </div>
                            </Router>
                        </UserProvider>
                    </AuthProvider>
                </ThemeProvider>
            </>
        )
    }
}

export default App
